
































import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import { IRefDetail } from "./RefsList.vue";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { MrfiktivPartnerCustomerUserViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";

@Component({
  components: {},
  filters: {}
})
class RefsCustomerAccount extends mixins(Vue) implements IRefDetail<MrfiktivPartnerCustomerUserViewModelGen> {
  @Prop()
  item!: MrfiktivPartnerCustomerUserViewModelGen;

  @Prop()
  small!: boolean;

  @Prop({ default: false })
  hideCustomerAccount!: boolean;

  @Prop({ default: false })
  hideDate!: boolean;

  @Prop()
  confirmable!: boolean;

  get date() {
    return simpleDoubleDigitDate(this.item.timestamp.created);
  }

  hasClickListener() {
    return Boolean(this.$listeners && this.$listeners.click);
  }

  hasOpenDetailListener() {
    return Boolean(this.$listeners && this.$listeners.openDetail);
  }

  emitOpenDetail() {
    this.$emit("openDetail", this.item);
  }

  async goToDetail() {
    throw Error("Not implemented yet");
  }
}

export default RefsCustomerAccount;
